/* eslint-disable import/no-anonymous-default-export */
const { REACT_APP_API_URL } = process.env;

export default {
    apiURL: REACT_APP_API_URL,
};